export default __webpack_public_path__ + "static/media/dosNu.207be4b8.png";